<template>
  <healthcheck-form
    id="0"
    :distribution-id="distributionId"
    @submit="addHealthcheck"
    @close="onClose"
  />
</template>
<script>
import HealthcheckForm from './Form.vue'

export default {
  name: 'CreateDistributionHealthcheck',
  components: {
    HealthcheckForm,
  },
  data() {
    return {
      distributionId: null,
    }
  },
  created() {
    this.distributionId = this.$route.params.id
  },
  methods: {
    addHealthcheck(healthcheck) {
      const query = {
        distributionId: this.distributionId,
        healthcheck: {
          name: healthcheck.name,
          requestMethod: healthcheck.requestMethod,
          requestPath: healthcheck.requestPath,
          host: healthcheck.host,
          expectedResponse: healthcheck.expectedResponse,
          threshold: healthcheck.threshold,
          window: healthcheck.window,
          interval: healthcheck.interval,
          timeout: healthcheck.timeout,
        },
      }
      this.$store.dispatch('cdn/addHealthcheck', query).then(() => {
        this.successToast('Healthcheck was added')
        this.onClose()
      }).catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while creating healthcheck.') })
    },

    onClose() {
      this.$router.push({ name: 'distribution-origins', params: { id: this.distributionId, activeTab: 2 } })
    },
  },
}
</script>
